/**
 * 応答タブの候補カードの一覧（Issue #467）。**一覧性重視**: 1 行 1 枚で、小さい画像・カード名・場所の文字（「手札」「相手のモンスター 3」）と、
 * 行動の問い合わせならその行の中に行動のボタン（通常召喚・セット・発動: 効果文）を並べる。カードの選択なら行を押して選ぶ（順番の札）。
 * 並びは respondModel.groupTiles の順（自分の手札 → 場 → 墓地… → 相手）。
 */
import { playerColor, usePlayerColors } from './common';

export const THUMB_W = 26;
export const THUMB_H = Math.round(THUMB_W * 86 / 59);

function Thumb({ image, name }) {
  return image
    ? <img alt="" src={image} width={THUMB_W} height={THUMB_H} style={{ objectFit: 'cover', borderRadius: 2, flexShrink: 0, display: 'block' }} />
    : <span title={name} style={{ width: THUMB_W, height: THUMB_H, borderRadius: 2, background: '#2a2f45', flexShrink: 0, display: 'block' }} />;
}

/** 1 行（行動のボタンは children） */
export function CardRow({ tile, player = 0, names = {}, thumbs = {}, selected = false, badge = null, onTap, disabled = false, children = null }) {
  const name = tile.code ? (names[tile.code] ?? tile.code) : '？';
  const mine = tile.controller === player;
  const colors = usePlayerColors();
  const head = (
    <>
      <Thumb image={tile.code ? thumbs[tile.code] : null} name={name} />
      <span style={{ minWidth: 0, flex: '1 1 auto', display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <span style={{ fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</span>
        <span style={{ fontSize: 11, color: mine ? '#9fb0cf' : (playerColor(tile.controller, colors) ?? colors[1]), whiteSpace: 'nowrap' }}>{tile.location_text ?? ''}</span>
      </span>
      {badge != null ? <span style={{ minWidth: 20, padding: '0 5px', borderRadius: 999, background: '#ffd36b', color: '#1b1308', fontSize: 11, fontWeight: 800, textAlign: 'center', flexShrink: 0 }}>{badge}</span> : null}
    </>
  );
  const rowStyle = { display: 'flex', alignItems: 'center', gap: 8, padding: '3px 6px', borderRadius: 6, minHeight: THUMB_H + 6, boxSizing: 'border-box',
    background: selected ? '#3b3420' : '#111a2d', border: `1px solid ${selected ? '#ffd36b' : '#1f2a44'}`, color: '#e8eefc' };
  return (
    <div data-testid="respond-row" data-tile={tile.id} data-selected={selected ? '1' : undefined} style={{ display: 'flex', flexDirection: 'column', gap: 4, scrollSnapAlign: 'start' }}>
      {onTap ? (
        <button type="button" data-testid="respond-row-tap" disabled={disabled} onClick={() => onTap(tile)} style={{ ...rowStyle, width: '100%', textAlign: 'left', cursor: 'pointer' }}>{head}</button>
      ) : (
        <div style={{ ...rowStyle, flexWrap: 'wrap' }}>
          {head}
          {children ? <span style={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'flex-end', marginLeft: 'auto', maxWidth: '100%' }}>{children}</span> : null}
        </div>
      )}
    </div>
  );
}

export const chip = { minHeight: 34, padding: '4px 10px', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#e8eefc', border: '1px solid #4fc3ff', background: '#1b4a6d',
  maxWidth: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

export default function CardRows({ groups = [], player = 0, names = {}, thumbs = {}, busy = false, mode = 'actions', picked = [], badgeOf = () => null, onAction, onToggle }) {
  const tiles = groups.flatMap((g) => g.tiles);
  return (
    <div data-testid="respond-rows" style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {tiles.map((t) => (mode === 'select' ? (
        <CardRow key={t.id} tile={t} player={player} names={names} thumbs={thumbs} disabled={busy} selected={picked.includes(t.index)} badge={badgeOf(t)} onTap={onToggle} />
      ) : (
        <CardRow key={t.id} tile={t} player={player} names={names} thumbs={thumbs}>
          {t.actions.map((a) => <button key={a.key} type="button" data-testid="respond-action" disabled={busy} style={chip} onClick={() => onAction?.(a.payload)}>{a.label}</button>)}
        </CardRow>
      )))}
    </div>
  );
}
